<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="election-length">
  <div class="p-30" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Durée du mandat</p>
        <p class="no-margin dark-gray text-sm">Durée des mandats des élus CSE</p>
      </div>
    </div>
  </div>

  <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="length-grid" class="p-30">
    <div>
      <p class="dark-blue no-margin">Années <span class="red">*</span></p>
      <input [(ngModel)]="termLength.duration[0]" (ngModelChange)="validateYears()" (wheel)="$event.preventDefault()"
        type="number" min="0" max="4" name="years" id="years" class="w-full text-md dark-blue pap-input"
        value="{{termLength.duration[0]}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Mois <span class="red">*</span></p>
      <input [(ngModel)]="termLength.duration[1]" (ngModelChange)="validateMonths()" (wheel)="$event.preventDefault()"
        type="number" min="0" max="11" name="months" id="months" class="w-full text-md dark-blue pap-input"
        value="{{termLength.duration[1]}}">
    </div>
    <p class="dark-gray text-xs no-margin">• Exemple : 4 années <br>• Exemple : 2 années et 9 mois</p>
    <div></div>
    <div>
      <label for="partial" class="dark-blue pointer">
        <input type="checkbox" name="partial" id="partial" [(ngModel)]="termLength.partial"
          (ngModelChange)="onLengthChange()">
        Élection partielle
      </label>
    </div>
  </div>
</div>